import _ from 'lodash'
import monthlyCosts from './monthlyCosts'
import oneTimeCosts from './oneTimeCosts'

export default (form) => _.concat(monthlyCosts(form), oneTimeCosts(form))
